.titleRow {
  margin-top: 2em;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.title {
  flex: auto;
}

.navigation {
  display: flex;
  justify-content: flex-end;
  padding-top: 1em;
  border-top: solid 0.1em var(--mediumSilver);
}
